(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.main-product').forEach((section) => {
    const form = section.querySelector('.main-product__form');
    const variantSelect = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    const fileInput = section.querySelector('[data-photo-input]');
    const fileName = section.querySelector('[data-file-name]');
    const preview = section.querySelector('[data-photo-preview]');
    const submit = section.querySelector('[data-submit]');
    const error = section.querySelector('[data-form-error]');

    if (variantSelect && price) {
      variantSelect.addEventListener('change', () => {
        price.textContent = variantSelect.options[variantSelect.selectedIndex].dataset.price;
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', () => {
        const file = fileInput.files && fileInput.files[0];
        if (!file) return;
        fileName.textContent = file.name;
        preview.src = URL.createObjectURL(file);
        preview.hidden = false;
      });
    }

    if (form && submit) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        submit.disabled = true;
        submit.textContent = submit.dataset.loadingLabel;
        error.hidden = true;
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('add_failed');
          window.location.assign('/checkout');
        } catch (requestError) {
          error.hidden = false;
          submit.disabled = false;
          submit.textContent = submit.dataset.defaultLabel;
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
